import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed } from "@nuxtjs/composition-api";
import { toCurrencyFormat } from '@/core/helpers/GlobalHelpers';
import { useMobile } from "~/core/composables/useMobile";
import { UserBalance } from "~/core/models/purchase-popup-2/UserBalance";
import MunicipalityTx from "~/core/models/purchase-popup-2/MunicipalityTx";
import Web3MunicipalityTx from "~/core/models/purchase-popup-2/Web3MunicipalityTx";

interface Props {
    userBalance: UserBalance,
    transactionObject: MunicipalityTx | Web3MunicipalityTx,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PapCurrencySelection',
  props: {
    userBalance: null,
    transactionObject: null
  },
  emits: ['onClickBack', 'onCurrencySelected'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { userBalance: UserBalance, transactionObject: MunicipalityTx | Web3MunicipalityTx };





const {
    userBalance,
    transactionObject,
} = toRefs(props);

const isMobile = useMobile();
const papAsset = computed(() => transactionObject.value.priceInfo.totalAmount);

return { __sfc: true,$emit, props, userBalance, transactionObject, isMobile, papAsset, toCurrencyFormat }
}

})